import NotificationIcon from "@/assets/icons/web_Icons/notification-bing.svg";
import { DownOutlined } from "@ant-design/icons";
import { Dropdown, Space } from "antd";
import PropTypes from "prop-types";
import NotificationItem from "@/pages/notifications/NotificationItem";
import { useState } from "react";

const items = [
  {
    label: <span>Messages</span>,
    key: "0",
  },
  {
    type: "divider",
  },
  {
    label: <span>Alerts</span>,
    key: "1",
  },
  {
    type: "divider",
  },
  {
    label: <span>Activities</span>,
    key: "3",
  },
];

const notificationsData = [
  {
    id: 1,
    text: "New API has been created successfully",
    time: "10:42:02 AM",
    date: "22/2/2022",
    read: true,
  },
  {
    id: 2,
    text: "New API has been created successfully",
    time: "10:42:02 AM",
    date: "22/2/2022",
    read: true,
  },
  {
    id: 3,
    text: "New API has been created successfully",
    time: "10:42:02 AM",
    date: "22/2/2022",
    read: false,
  },
  {
    id: 4,
    text: "New API has been created successfully",
    time: "10:42:02 AM",
    date: "22/2/2022",
    read: false,
  },
  {
    id: 5,
    text: "New API has been created successfully",
    time: "10:42:02 AM",
    date: "22/2/2022",
    read: false,
  },
  {
    id: 6,
    text: "New API has been created successfully",
    time: "10:42:02 AM",
    date: "22/2/2022",
    read: false,
  },
  {
    id: 7,
    text: "New API has been created successfully",
    time: "10:42:02 AM",
    date: "22/2/2022",
    read: false,
  },
  {
    id: 8,
    text: "New API has been created successfully",
    time: "10:42:02 AM",
    date: "22/2/2022",
    read: false,
  },
  {
    id: 9,
    text: "New API has been created successfully",
    time: "10:42:02 AM",
    date: "22/2/2022",
    read: false,
  },
  {
    id: 10,
    text: "New API has been created successfully",
    time: "10:42:02 AM",
    date: "22/2/2022",
    read: false,
  },
];

const Notifications = () => {
  const [notifications, setNotifications] = useState(notificationsData);

  const toggleRead = (id) => {
    setNotifications((prevNotifications) =>
      prevNotifications.map((notif) =>
        notif.id === id ? { ...notif, read: !notif.read } : notif
      )
    );
  };

  return (
    <div className="text-left">
      <div className="flex items-center gap-4 p-2 border-b">
        <div className="p-2 border rounded-lg">
          <img src={NotificationIcon} alt="" />
        </div>
        <div>
          <h2 className="font-bold text-[15px]">Notifications</h2>
          <p className="text-sm">
            Manage all your notifications, alerts, and messages here
          </p>
        </div>
      </div>
      <div className="py-4 sm:p-4">
        <div className="flex items-center justify-between font-bold">
          <Dropdown
            menu={{
              items,
            }}
            trigger={["click"]}>
            <a onClick={(e) => e.preventDefault()}>
              <Space>
                Notifications Type
                <DownOutlined />
              </Space>
            </a>
          </Dropdown>
          <p>32 Unread</p>
        </div>
        <div className="">
          <div className="">
            {notifications.map((notif) => (
              <NotificationItem
                key={notif.id}
                notification={notif}
                onToggleRead={toggleRead}
              />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

Notifications.propTypes = {
  notificationsData: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      text: PropTypes.string,
      time: PropTypes.string,
      date: PropTypes.string,
      read: PropTypes.bool,
    })
  ),
};

export default Notifications;
